import { useState, useEffect } from 'react';
import { supabase } from './supabase';
import { CATEGORIES } from '../utils/constants';

export const useStatistics = () => {
  const [stats, setStats] = useState({
    totalPosts: 0,
    totalCategories: CATEGORIES.length, // Local categories count
    featuredPosts: 0,
    trendingPosts: 0,
    todayPosts: 0,
    loading: true,
    error: null
  });

  useEffect(() => {
    fetchStatistics();
  }, []);

  const fetchStatistics = async () => {
    try {
      // Fetch posts statistics
      const { data: posts, error: postsError } = await supabase
        .from('posts')
        .select('is_featured, is_trending, created_at');

      if (postsError) throw postsError;

      // Calculate statistics
      const today = new Date();
      today.setHours(0, 0, 0, 0);

      const statistics = {
        totalPosts: posts?.length || 0,
        totalCategories: CATEGORIES.length, // Using local categories
        featuredPosts: posts?.filter(p => p.is_featured).length || 0,
        trendingPosts: posts?.filter(p => p.is_trending).length || 0,
        todayPosts: posts?.filter(p => new Date(p.created_at) >= today).length || 0,
        loading: false,
        error: null
      };

      setStats(statistics);
    } catch (error) {
      console.error('Error fetching statistics:', error);
      setStats(prev => ({
        ...prev,
        loading: false,
        error: error.message
      }));
    }
  };

  const refreshStats = () => {
    setStats(prev => ({ ...prev, loading: true }));
    fetchStatistics();
  };

  return { ...stats, refreshStats };
};
